/*eslint-disable */

let $ = window.jQuery;

$(document).ready(function () {
	let $accordions = $('.c-accordion__wrapper');
	let $accordion = $('.c-accordion');
	let $accordionTitle = $('.c-accordion__title');
	let $accordionContent = $('.c-accordion__content');

    if ($accordions.length > 0) {
        $accordionTitle.on('click', function (){
            $(this).parent().siblings().find($accordionTitle).removeClass('active').next().slideUp(250).parent().find('.c-accordion__indicator').removeClass('active');;
            $(this).find('.c-accordion__indicator').toggleClass('active');
            $(this).toggleClass('active').next().slideToggle(250);
        });
    }
});

/*eslint-ensable */
